import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=1bf63c1e"
var script = {}
import style0 from "./Overlay.vue?vue&type=style&index=0&id=1bf63c1e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports